import _ from 'lodash'

export const getCurrentImage = name => state =>
  _.find(state.cropper.images, ({ file }) => file.name === name)



/** WEBPACK FOOTER **
 ** ./src/selectors/cropper/cropper-selectors.js
 **/